import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Box,
  VStack,
  Text,
} from "@chakra-ui/react";
import Button from "components/Button/Button";
import Uploader from "components/Uploader/Uploader";
import { isEmpty } from "lodash";
import { useCallback, useMemo, useState } from "react";

export default function MessageFileUpload(props) {
  const { isOpen, onClose, isLoading, onAdd, buttonText } = props;

  const [state, setState] = useState({ files: [] });

  const set = useCallback(
    (update) => setState((old) => ({ ...old, ...update })),
    []
  );

  console.log("attachment", state);

  const isDisabled = useMemo(
    () => !state?.files || (state?.files && isEmpty(state.files)),
    [state?.files]
  );

  const addAttachment = async () => {
    if (!isDisabled) {
      const file = state?.files[0];
      onAdd && onAdd(file);
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent
        maxW="500px"
        bg="#F8F9FD"
        overflow="hidden"
        borderRadius="16px"
      >
        <ModalHeader p="26px" textAlign="left" bg="white" fontSize="md">
          Add Attachments
        </ModalHeader>

        <ModalBody p="24px 38px">
          <Box>
            <VStack
              justify="center"
              w="100%"
              p={["26px 0", "26px 0", "26px"]}
              gridGap="12px"
            >
              <Uploader
                maxFiles={1}
                files={state?.files}
                onFiles={(files) => set({ files })}
                changeButtonText="Change attachment"
              />
              <Text m="0 !important" color="#4E4B66" fontSize=".8em">
                Upload .PDF/.JPG/.JPEG/.PNG file and no more than 5M
              </Text>
            </VStack>
          </Box>
        </ModalBody>

        <ModalFooter justifyContent="center" pb="30px" gridGap="14px">
          <Button
            disabled={isLoading}
            minW="120px"
            onClick={onClose}
            bg="transparent"
            border="2px solid transparent"
            color="#03A438"
          >
            {(buttonText && buttonText[0]) ?? "Cancel"}
          </Button>
          <Button
            disabled={isLoading || isDisabled}
            isLoading={isLoading}
            minW="120px"
            onClick={addAttachment}
            // disabled={isDisabled}
          >
            {(buttonText && buttonText[1]) ?? "Done"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
